import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tenantConfigurationApi } from '@/api/services/tenantConfiguration';
import type { TenantConfigurationDto } from '@/api/types/tenantConfiguration';

export const tenantConfigurationKeys = {
  all: ['tenantConfiguration'] as const,
  detail: ['tenantConfiguration', 'detail'] as const,
};

export function useTenantConfiguration() {
  return useQuery({
    queryKey: tenantConfigurationKeys.detail,
    queryFn: () => tenantConfigurationApi.get(),
  });
}

export function useUpdateTenantConfiguration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TenantConfigurationDto) => tenantConfigurationApi.update(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantConfigurationKeys.detail }),
  });
}
